import { createContext, useContext, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { BookingModal } from "../components/booking/BookingModal";

const BookingContext = createContext({ openBooking: () => {} });
export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [state, setState] = useState(null); // { mode: 'choose'|'tour', tour, offer }

  const openBooking = (opts = {}) =>
    setState({ mode: opts.mode || "choose", tour: opts.tour || null, offer: opts.offer || null });
  const closeBooking = () => setState(null);

  return (
    <BookingContext.Provider value={{ openBooking }}>
      {children}
      <AnimatePresence>
        {state && <BookingModal state={state} onClose={closeBooking} />}
      </AnimatePresence>
    </BookingContext.Provider>
  );
};
